import React, { memo, useCallback, useContext } from 'react';
import { connect } from 'react-redux';
import get from 'lodash.get';
import { FixedSizeList as List } from 'react-window';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
import { VirtualizedTableItemKey } from 'services/virtualizedTable/types';

import { VirtualizedTableContextProviderValue } from '../../types';
import VirtualizedTableRowsWrapper from '../VirtualizedTableRowsWrapper';
import VirtualizedTableRowWrapper from '../VirtualizedTableRowWrapper';
import { selectItemKeys } from '../../selectors';
import { ROW_HEIGHT, HEADER_INDEX_OFFSET } from '../../constants';
import VirtualizedTableContext from '../VirtualizedTableContext';

export interface OwnProps {
    height: number;
    width: number;
}

export interface ConnectedProps {
    itemKeys: VirtualizedTableItemKey[];
}

export type Props = OwnProps & ConnectedProps;

export const VirtualizedTableBodyComponent = (
    props: Props
): React.ReactElement | null => {
    const { height, width, itemKeys } = props;

    const {
        labelPlural = '',
        enableFooter
    }: VirtualizedTableContextProviderValue = useContext(
        VirtualizedTableContext
    );

    const getItemKey = useCallback(
        (index: number): string | undefined =>
            get(itemKeys, index - HEADER_INDEX_OFFSET),
        [itemKeys]
    );

    // Add an extra row to allow for the header
    let itemCount = itemKeys.length + HEADER_INDEX_OFFSET;
    const isEmpty = !itemKeys.length;

    if (enableFooter && !isEmpty) {
        // Add an extra row to allow for the footer
        itemCount += 1;
    }

    if (isEmpty) {
        // Add an extra row so it can display the empty table messsage
        itemCount += 1;
    }

    return (
        <List
            className="ui virtualized-table sortable"
            height={height}
            itemCount={itemCount}
            itemSize={ROW_HEIGHT}
            width={width}
            itemData={
                {
                    getItemKey,
                    labelPlural,
                    isEmpty: !itemKeys.length
                } as any
            }
            innerElementType={VirtualizedTableRowsWrapper}
        >
            {VirtualizedTableRowWrapper}
        </List>
    );
};

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    itemKeys: selectItemKeys
});

export default connect(mapStateToProps)(memo(VirtualizedTableBodyComponent));
